// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Content__Wrapper_3Bumg grid grid--col-12","ColLeft":"Content__ColLeft_ntCD5","ColRight":"Content__ColRight_2NmVs d-none d-sm-block","Heading":"Content__Heading_MuJZx"};